module.exports = __webpack_public_path__ + "static/media/Portrait-10188.386501f5.jpg";